//@ts-check
import store from '../../store';

var addTrailingSlash = function addTrailingSlash(host) {
  if (!host) return host;
  if (host.endsWith('/')) return host;
  return host + '/';
};

var clean = function clean(host) {
  if (!host) return host;
  host = addTrailingSlash(host);
  return host;
};
/**
 * @type {import("./types").getHostType}
 */


export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    useMicroserviceBackend: false
  },
      useMicroserviceBackend = _ref.useMicroserviceBackend;

  var state = store.getState();
  if (useMicroserviceBackend) return clean(state.auth.microserviceServer);
  return clean(state.auth.ecrionServer);
});